export const companyConstants = {
    GET_COMPANY_DETAILS_REQUEST: "GET_COMPANY_DETAILS_REQUEST",
    GET_COMPANY_DETAILS_SUCCESS: "GET_COMPANY_DETAILS_SUCCESS",
    GET_COMPANY_DETAILS_FAILURE: "GET_COMPANY_DETAILS_FAILURE",

    EDIT_COMPANY_PROFILE_REQUEST: "EDIT_COMPANY_PROFILE_REQUEST",
    EDIT_COMPANY_PROFILE_SUCCESS: "EDIT_COMPANY_PROFILE_SUCCESS",
    EDIT_COMPANY_PROFILE_FAILURE: "EDIT_COMPANY_PROFILE_FAILURE",

    GET_COMPANY_LOGO_REQUEST: "GET_COMPANY_LOGO_REQUEST",
    GET_COMPANY_LOGO_SUCCESS: "GET_COMPANY_LOGO_SUCCESS",
    GET_COMPANY_LOGO_FAILURE: "GET_COMPANY_LOGO_FAILURE",

    GET_DASHBOARD_DROPDOWN_DATA_REQUEST: "GET_DASHBOARD_DROPDOWN_DATA_REQUEST",
    GET_DASHBOARD_DROPDOWN_DATA_SUCCESS: "GET_DASHBOARD_DROPDOWN_DATA_SUCCESS",
    GET_DASHBOARD_DROPDOWN_DATA_FAILURE: "GET_DASHBOARD_DROPDOWN_DATA_FAILURE",

    GET_COST_DASHBOARD_DATA_REQUEST: "GET_COST_DASHBOARD_DATA_REQUEST",
    GET_COST_DASHBOARD_DATA_SUCCESS: "GET_COST_DASHBOARD_DATA_SUCCESS",
    GET_COST_DASHBOARD_DATA_FAILURE: "GET_COST_DASHBOARD_DATA_FAILURE",
};